jQuery( document ).ready(function( $ ) {
  const entryTitle = document.querySelector('.page-title-default .entry-title');
if (entryTitle && entryTitle.textContent === 'Blog') {
    entryTitle.textContent = 'Recipe';
}


var image = document.querySelector('.qw .pr'); 
    var linkURL = 'https://www.quickwhip.co.uk/collections/cream-chargers'; 

    // Create a new anchor tag
    var link = document.createElement('a');
    link.href = linkURL;
 

    // Insert the image inside the anchor tag
    image.parentNode.insertBefore(link, image);
    link.appendChild(image);

var image = document.querySelector('.qw1 .pr'); 
    var linkURL = 'https://www.quickwhip.co.uk/collections/whipped-cream-dispensers'; 

    // Create a new anchor tag
    var link = document.createElement('a');
    link.href = linkURL;
   

    // Insert the image inside the anchor tag
    image.parentNode.insertBefore(link, image);
    link.appendChild(image);

var image = document.querySelector('.qw2 .pr'); 
    var linkURL = 'https://www.quickwhip.co.uk/collections'; 

    // Create a new anchor tag
    var link = document.createElement('a');
    link.href = linkURL;
 

    // Insert the image inside the anchor tag
    image.parentNode.insertBefore(link, image);

    link.appendChild(image);
});